import React from 'react';

/**
 * Signed-out shell.
 *
 * A single centred column on the brand navy — the layout banking software
 * actually uses. The previous 50/50 split stranded a 360px form in a large
 * empty white half and gave the other half to stock illustration. Centring
 * removes the dead space and puts the credentials where the eye lands first;
 * the ground is flat navy with a faint rule grid, so nothing competes with the
 * two fields that matter.
 */
const AuthLayout = ({ children, footnote }) => (
    <div
        className="relative min-h-screen flex flex-col items-center justify-center px-4 py-10 overflow-hidden"
        style={{ backgroundColor: 'var(--bg-sidebar)' }}
    >
        {/* Ground texture: 1px rules at ~5% white, faded out towards the edges. */}
        <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0"
            style={{
                backgroundImage:
                    'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px),' +
                    'linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)',
                backgroundSize: '56px 56px',
                maskImage: 'radial-gradient(ellipse 75% 60% at 50% 45%, #000 35%, transparent 100%)',
                WebkitMaskImage:
                    'radial-gradient(ellipse 75% 60% at 50% 45%, #000 35%, transparent 100%)',
            }}
        />

        <main className="relative w-full max-w-[400px]">
            <div className="flex flex-col items-center text-center mb-6">
                <img
                    src="/logo blue.png"
                    alt="MyBank"
                    className="w-auto object-contain brightness-0 invert"
                    style={{ height: 38, maxWidth: 190 }}
                />
                <p className="mt-3 text-base" style={{ color: 'var(--text-sidebar)' }}>
                    Project, task and meeting management for the ICT department
                </p>
            </div>

            <div className="bg-white rounded-lg shadow-lg px-6 py-7 sm:px-8">{children}</div>

            {footnote && (
                <p
                    className="mt-4 text-label text-center leading-relaxed"
                    style={{ color: 'var(--text-sidebar)' }}
                >
                    {footnote}
                </p>
            )}
        </main>

        <footer
            className="relative mt-8 text-micro text-center"
            style={{ color: 'var(--text-sidebar-label)' }}
        >
            © {new Date().getFullYear()} MyBank · Internal use only
        </footer>
    </div>
);

export default AuthLayout;
